export const STATUS_INCOMPLETE = 'INCOMPLETE';
export const STATUS_SUBMITTED = 'SUBMITTED';
export const STATUS_KICKBACK = 'KICKBACK';
